<template>
<div class='bodyer index'>
    <div id='loop-banner' class='carousel slide loop-banner' data-interval='2000'>
        <ol class='carousel-indicators'>
            <li data-target='#loop-banner' data-slide-to='0' class='active'></li>
            <li data-target='#loop-banner' data-slide-to='1'></li>
            <li data-target='#loop-banner' data-slide-to='2'></li>
            <li data-target='#loop-banner' data-slide-to='3'></li>
            <li data-target='#loop-banner' data-slide-to='4'></li>
        </ol>
        <div class='carousel-inner'>
            <div class='item active'>
                <img src='/static/image/index/banner.jpg'>
            </div>
            <div class='item'>
                <img src='/static/image/index/banner02.jpg'>
            </div>
            <div class='item'>
                <img src='/static/image/index/banner03.jpg'>
            </div>
            <div class='item'>
                <img src='/static/image/index/banner05.jpg'>
            </div>
            <div class='item'>
                <img src='/static/image/index/ybcs_1.jpg'>
            </div>
        </div>
        <a class='carousel-control left' href='#loop-banner'data-slide='prev'> 
            <span class='glyphicon glyphicon-chevron-left'></span>
        </a>
        <a class='carousel-control right' href='#loop-banner'data-slide='next'> 
            <span class='glyphicon glyphicon-chevron-right'></span>
        </a>
    </div>
    <div class='banner-nav'>
        <div class='bg-color'></div>
        <div class='container'>
            <div class='row'>
                <div class='col-md-2 col-md-offset-1'>
                    <div class='nav wrap-shake' @click='toUrl("/register")'>
                        <div class='nav-icon'>
                            <img src='/static/image/index/p2-register.png' class='shake'>
                        </div>
                        <div class='nav-name'>注册</div>
                    </div>
                </div>
                <div class='col-md-2'>
                    <div class='nav wrap-shake'>
                        <div class='nav-icon' @click='toUrl("/recharge")'>
                            <img src='/static/image/index/p2-recharge.png' class='shake'>
                        </div>
                        <div class='nav-name'>充值</div>
                    </div>
                </div>
                <div class='col-md-2'>
                    <div class='nav wrap-shake'>
                        <div class='nav-icon' @click='toM2DownLoadUrl()'>
                            <img src='/static/image/index/p2-download.png' class='shake'>
                        </div>
                        <div class='nav-name'>下载</div>
                    </div>
                </div>
                <div class='col-md-2'>
                    <div class='nav wrap-shake'>
                        <div class='nav-icon'  @click='callAbbr()'>
                            <img src='/static/image/index/p2-service.png' class='shake'>
                        </div>
                        <div class='nav-name'>客服</div>
                    </div>
                </div>
                <div class='col-md-2'>
                    <div class='nav wrap-shake'>
                        <div class='nav-icon' @click='toUrl("/user")'>
                            <img src='/static/image/index/p2-safe.png' class='shake'>
                        </div>
                        <div class='nav-name'>安全</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class='m-news' v-if='news.list'>
        <div class='container'>
            <div class='row'>
                <div class='col-md-8'>
                    <div class='news-list'>
                        <div class='yi-title'>
                            新闻 ● 热门活动<i class='fa fa-navicon pull-right' @click="toUrl('/news/list')"></i>
                        </div>
                        <ul>
                            <li v-for='item in news.list' @click='toNews(item)'>
                               <!-- <span class='type'>【行业新闻】</span>-->
                                {{item.title_sim}}
                                <span class='date'>{{item.created_at}}</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class='col-md-4'>
                    <div class='news-pic' @click='toNews(news.pic)'>
                        <img :src='news.pic.banner'>
                        <div class='title'>
                            {{news.pic.title_sim}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class='m-game'>
        <div class='container'>
            <div class='yi-title'>
                热门游戏
                <span class='box-angle pull-right'><i class='fa fa-angle-right'></i></span>
                <span class='box-angle pull-right'><i class='fa fa-angle-left'></i></span>
            </div>
            <div class='row'>
                <div class='col-md-3' v-for='item in games'>
                    <div class='game'>
                        <div :class='"tag "+item.tag' v-if='item.tag'></div>
                        <div class='pic'>
                            <img :src='item.poster'>
                            <div class='mask'>
                                <div class='_name'>{{item.name}}</div>
                                <div class='_start'>
                                    <i></i><i></i><i></i><i></i><i></i>
                                </div>
                                <div class='_download' v-if="item.link">
                                    <div class='_btn' @click='gotoGw(item.link)'>
                                        <img src='/static/image/index/icon-down.png'>
                                        立即下载
                                    </div>
                                </div>
                                <div class='_download' v-else>
                                    <div class='_btn'>
                                        <img src='/static/image/index/icon-down.png'>
                                        预约中
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class='name'>{{item.name}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class='banner-02'>
        <img src='/static/image/index/banner02.png'>
    </div>
    <div class='m-game-class'>
        <div class='container'>
            <div class='yi-title'><b>游戏列表</b></div>
            <div class='row'>
                <div class='col-md-4'>
                    <div class='g-class'>
                        <div class='title'>客户端游戏</div>
                        <div class='content'>
                            <div class='game' @click='toM2Url("/")'>
                                <img src='/static/image/index/icon-hot.png'>
                                M2神甲奇兵
                            </div>
                            <div class='game' @click='toLapisUrl("/")'>
                               <!-- <img src='/static/image/index/icon-hot.png'>-->
                                佣兵传说
                            </div>
                            <!--<div class='game' @click='toM2Url("/")'>
                                <img src='/static/image/index/icon-new.png'>
                                佣兵传说
                            </div>-->
                        </div>
                    </div>
                </div>
                <div class='col-md-4'>
                    <div class='g-class'>
                        <div class='title'>手机游戏</div>
                        <div class='content'>
                            <div class='game' @click='toFjsgUrl("/")'>
                                <img src='/static/image/index/icon-hot.png'>
                                富甲三国
                            </div>
                        </div>
                    </div>
                </div>
                <div class='col-md-4'>
                    <div class='g-class'>
                        <div class='title'>网页游戏</div>
                        <div class='content'>
                            <div class='game'>
                                <!--<img src='/static/image/index/icon-hot.png'>-->
                                敬请期待
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class='m-link'>
        <div class='container'>
            <me-link></me-link>
        </div>
    </div>
</div>
</template>

<script type="text/javascript">
import Storage from '@/common/Storage'
import Request from '@/common/Request'
import Common from '@/common/Common'
import ScrollReveal from 'scrollreveal'
import Link from '@/components/util/Link'
export default {
    data: function(){
        return {
            'games' : [
                {
                    'name' : 'M2神甲奇兵',
                    'poster' : '/static/image/index/g-01.png',
                    'tag' : 'new',
                    'link' : 'toM2Url'
                },
                {
                    'name' : '富甲三国',
                    'poster' : '/static/image/index/g-05.jpg',
                    'tag' : 'new',
                    'link' : 'toFjsgUrl'
                },
                {
                    'name' : '佣兵传说',
                    'poster' : '/static/image/index/ybcs_hot.jpg',
                    'tag' : 'new',
                    'link' : 'toLapisUrl'
                },
            ],

            'news' : {
                'list' : false,
                'pic': false
            }
        }
    },
    methods: {
        'getNews' : function(){
            var url = Request.createApi('/app/news/list?where[position]=list&page=1&limit=4')
            Request.get(url, res => {
                this.news.list = res.list
            })

            var url = Request.createApi('/app/news/list?where[position]=image&page=1&limit=1')
            Request.get(url, res => {
                this.news.pic = res.list[0]
            })
        },

        'toNews' : function(news){
            Storage.set('news', news)
            Common.toUrl('/news/item?id='+news.id)
        },

        'toUrl' : function(url){
            Common.toUrl(url)
        },

        'toM2Url' : function(url){
            Common.toM2Url(url)
            return true
        },

        'toFjsgUrl' : function(url){
            Common.toFjsgUrl(url)
            return true
        },

        'toLapisUrl' : function(url){
            Common.toLapisUrl(url)
            return true
        },

        'toM2DownLoadUrl' : function(){
            Common.toM2DownLoadUrl()
        },

        'callAbbr' : function(){
            Common.callAbbr()
        },

        'gotoGw' : function (methodName) {
            if (methodName == 'toM2Url') {
                Common.toM2Url('/')
                return true
            } else if (methodName == 'toFjsgUrl') {
                Common.toFjsgUrl('/')
                return true
            } else if (methodName == 'toLapisUrl') {
                Common.toLapisUrl('/')
                return true
            }
        }
    },
    mounted: function(){
        var show = ScrollReveal({
            'origin' : 'bottom',
            'distance' : '100px',
            'duration' : 400,
            'delay' : 400
        });

        $('.banner-nav .nav').each(function(k){
            show.reveal($(this), {
                'delay' : k * 200 + 200,
                'origin' : 'right'
            })
        })

        show.reveal('.news-list', {
            'origin' : 'left'
        }).reveal('.news-pic', {
            'orgin' : 'right'
        })

        $('.m-game .game').each(function(k){
            show.reveal($(this), {
                delay : k * 200 + 200
            })
        })

        $('.m-game-class .g-class').each(function(k){
            show.reveal($(this), {
                delay : k * 200 + 200
            })
        })

        $('.m-link .c-link-class').each(function(k){
            show.reveal($(this), {
                delay : k * 200 + 200
            })
        })
    },
    created: function(){
        window.scrollTo(0, 0)
        this.getNews()
    },
    components: {
        'me-link' : Link
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Index.vue